import { Concept } from '../models/Entities/Contracts/Concept';
import { NewConcept } from '../models/Entities/Contracts/NewConcept';
import { ConceptParameters } from '../models/Entities/Contracts/ConceptParameters';
import { apiRequest, buildURL } from './commons/CommonService.Functions';

const BaseURL = process.env.REACT_APP_BILLER_API_GATEWAY + 'concepts';

const buildConceptsUrl = (parameters?: ConceptParameters): string => {
  if (!parameters || (parameters.pageNumber === undefined && parameters.pageSize === undefined)) {
    return BaseURL;
  }

  const queryParams = new URLSearchParams();
  if (parameters.pageNumber !== undefined) {
    queryParams.append('pageNumber', parameters.pageNumber.toString());
  }
  if (parameters.pageSize !== undefined) {
    queryParams.append('pageSize', parameters.pageSize.toString());
  }

  const query = queryParams.toString();
  return query ? `${BaseURL}?${query}` : BaseURL;
};

export const GetAllConcepts = async (token: string, parameters?: ConceptParameters): Promise<Concept[]> => {
  const requestUrl = buildConceptsUrl(parameters);
  return apiRequest<Concept[]>(requestUrl, token, 'GetAllConcepts');
};

export const GetConceptById = async (token: string, conceptId: number): Promise<Concept> => {
  const requestUrl = buildURL(BaseURL, conceptId);
  return apiRequest<Concept>(requestUrl, token, 'GetConceptById');
};

export const CreateConcept = async (token: string, concept: NewConcept): Promise<Concept> => {
  return apiRequest<Concept>(BaseURL, token, 'CreateConcept', {
    method: 'POST',
    body: JSON.stringify(concept)
  });
};

export const UpdateConcept = async (token: string, concept: Concept): Promise<Concept> => {
  return apiRequest<Concept>(BaseURL, token, 'UpdateConcept', {
    method: 'PUT',
    body: JSON.stringify(concept)
  });
};

export const DeleteConcept = async (token: string, conceptId: number): Promise<boolean> => {
  const requestUrl = buildURL(BaseURL, conceptId);
  return apiRequest<boolean>(requestUrl, token, 'DeleteConcept', {
    method: 'DELETE'
  });
};
